import { Instagram, MessageCircle, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{ backgroundColor: '#5C2424' }}
    >
      {/* Airmail stripe at the very top of footer */}
      <div className="airmail-stripe-divider" />

      <div className="container-miso" style={{ paddingTop: '64px', paddingBottom: '32px' }}>
        {/* Main footer row */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '40px',
            alignItems: 'center',
            marginBottom: '48px',
          }}
        >
          {/* Left: Logo + city */}
          <div>
            <span
              data-testid="footer-logo"
              style={{
                fontFamily: 'Canela, Georgia, serif',
                fontWeight: 500,
                fontSize: '22px',
                letterSpacing: '3px',
                color: '#FAF5EF',
                display: 'block',
                marginBottom: '6px',
              }}
            >
              miso
            </span>
            <span
              style={{
                fontFamily: 'Graphik, sans-serif',
                fontWeight: 500,
                fontSize: '13px',
                color: 'rgba(250,245,239,0.55)',
                display: 'block',
              }}
            >
              Hyderabad, India
            </span>
          </div>

          {/* Center: tagline */}
          <div style={{ textAlign: 'center' }}>
            <p
              style={{
                fontFamily: 'Graphik, sans-serif',
                fontWeight: 400,
                fontStyle: 'italic',
                fontSize: '15px',
                color: 'rgba(250,245,239,0.6)',
                margin: 0,
                lineHeight: 1.5,
              }}
            >
              take a photo. leave a message.<br />
              send a little love.
            </p>
          </div>

          {/* Right: Social links */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              justifyContent: 'flex-end',
            }}
          >
            <a
              href="https://instagram.com/miso.hyd"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              title="Instagram @miso.hyd"
              style={{
                color: 'rgba(250,245,239,0.6)',
                transition: 'color 0.2s ease',
                display: 'flex', alignItems: 'center', gap: '6px',
                fontFamily: 'Graphik, sans-serif',
                fontSize: '13px',
                textDecoration: 'none',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#FAF5EF'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(250,245,239,0.6)'; }}
            >
              <Instagram size={16} strokeWidth={1.5} />
              Instagram
            </a>
            <a
              href="https://wa.me/917013248755"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              title="WhatsApp"
              style={{
                color: 'rgba(250,245,239,0.6)',
                transition: 'color 0.2s ease',
                display: 'flex', alignItems: 'center', gap: '6px',
                fontFamily: 'Graphik, sans-serif',
                fontSize: '13px',
                textDecoration: 'none',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#FAF5EF'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(250,245,239,0.6)'; }}
            >
              <MessageCircle size={16} strokeWidth={1.5} />
              WhatsApp
            </a>
            <a
              href="mailto:hello@miso.in"
              data-testid="footer-email"
              title="Email"
              style={{
                color: 'rgba(250,245,239,0.6)',
                transition: 'color 0.2s ease',
                display: 'flex', alignItems: 'center', gap: '6px',
                fontFamily: 'Graphik, sans-serif',
                fontSize: '13px',
                textDecoration: 'none',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#FAF5EF'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(250,245,239,0.6)'; }}
            >
              <Mail size={16} strokeWidth={1.5} />
              Email
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid rgba(250,245,239,0.1)',
            paddingTop: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '12px',
          }}
        >
          <span
            style={{
              fontFamily: 'Graphik, sans-serif',
              fontWeight: 400,
              fontSize: '12px',
              color: 'rgba(250,245,239,0.35)',
            }}
          >
            © 2026 MISO Experiences
          </span>
          <span
            style={{
              fontFamily: 'Graphik, sans-serif',
              fontWeight: 400,
              fontSize: '12px',
              color: 'rgba(250,245,239,0.35)',
            }}
          >
            hello@miso.in
          </span>
        </div>
      </div>
    </footer>
  );
}
